module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "short-page"
  }, [_c('panel', [_c('p', {
    slot: "header"
  }, [_vm._v("\n            " + _vm._s(_vm.msg) + "\n        ")]), _vm._v(" "), _c('ui-button', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.goLogin($event)
      }
    }
  }, [_vm._v("Zaloguj się")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d72fedb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 225
// module chunks = 0